import React from "react";
import Button, { ButtonStyle } from "../Button";
import Spinner from "../Spinner";
import { RefreshIcon } from "../../icons";

type TabsProps = {
  tabs: React.ReactNode[];
  onRefresh?: () => void;
  isLoading?: boolean;
};

export const checkTabIsActive = ({ isActive }: { isActive: boolean }) =>
  "whitespace-nowrap py-2 px-1 border-b text-m font-normal " +
  (isActive
    ? "border-gray-800 border-b-2 text-gray-800"
    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300");

const Tabs = ({ tabs, onRefresh, isLoading = false }: TabsProps) => {
  return (
    <div className="block mb-4">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs}
          {onRefresh && (
            <div className="ml-auto flex-grow flex justify-end mb-1">
              <Button
                onClick={onRefresh}
                type={ButtonStyle.TERTIARY}
                text={
                  isLoading ? (
                    <Spinner.Inline />
                  ) : (
                    <div className="flex items-center">
                      <RefreshIcon className="w-4 h-4" />
                      <span className="ml-2">Refresh</span>
                    </div>
                  )
                }
              />
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};

export default Tabs;
